// UI state actions
export const SHOW_OVERLAY = 'uiState/SHOW_OVERLAY';
export const HIDE_OVERLAY = 'uiState/HIDE_OVERLAY';

export function showOverlayAction(overlayType, overlayData) {
  return {
    type: SHOW_OVERLAY,
    overlayType,
    overlayData,
  };
}

export function hideOverlayAction() {
  return {type: HIDE_OVERLAY};
}
